export function initializeOptionalFeature(name, factory, {
  onError = console.error
} = {}) {
  try {
    return factory();
  } catch (error) {
    onError(`${name} could not be initialized.`, error);
    return null;
  }
}

// Callers can expose the chart immediately while postponing persistence until
// every optional panel has finished restoring its own state.
export function hydrateOptionalFeatures(tasks, onSettled) {
  return Promise.allSettled(tasks.map(task => Promise.resolve().then(task))).then(results => {
    onSettled(results);
    return results;
  });
}
